import { requestFormPost } from '@/common/request';

export interface pageParams {
  page: number;
  pageSize: number;
  queryType: number;
  marketSceneTags: Array<undefined> | [];
  activityTypeTags: Array<undefined> | [];
  cardActivityName: string;
  cardActivityId: string;
  minActivityBeginTime: string;
  maxActivityBeginTime: string;
  orderBy: string;
}

type TagItem = { classify: number; code: string; name: string; remark: string };

export interface pageRes {
  ret: string;
  msg: string;
  data: {
    page: number;
    pageSize: number;
    totalCount: number;
    totalPage: number;
    items:
      | Array<{
          appliedFlag: number;
          canApplyFlag: number;
          collectionFlag: number;
          cardPublishTime: number;
          cardApplyEndTime: number;
          cardActivityName: string;
          cardActivityId: string;
          cardActivityType: number;
          cardBeginTime: number;
          cardEndTime: number;
          cardActivityDesc: string;
          marketSceneTags: Array<TagItem> | [];
          activityTypeTags: Array<TagItem> | [];
          activityFeatureTags: TagItem[];
        }>
      | [];
  };
}

//
export async function page(params: pageParams): Promise<pageRes> {
  return await requestFormPost('/generic/mac/square/page', params);
}
